var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"game-results-container"},[_vm._v(" Please click on \"Finish Game\" to complete the game ")])
}
var staticRenderFns = []

export { render, staticRenderFns }